import { ActionType, PayloadErrorType } from '../../types/reduxTypes';
import {
  CLEAR_SIGNUP_DATA,
  REQUEST_SIGNUP,
  REQUEST_SIGNUP_FAILED,
  REQUEST_SIGNUP_SUCCESS,
  RESEND_APPROVE_EMAIL,
} from '../constants';

export type SignUpPayloadType = {
  email: string;
  password: string;
};

export function clearSignupData(): ActionType {
  return {
    payload: null,
    type: CLEAR_SIGNUP_DATA,
  };
}
export function requestSignup(payload: SignUpPayloadType): ActionType<SignUpPayloadType> {
  return {
    payload,
    type: REQUEST_SIGNUP,
  };
}
export function requestSignupFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: REQUEST_SIGNUP_FAILED,
  };
}
export function requestSignupSuccess(): ActionType {
  return {
    payload: null,
    type: REQUEST_SIGNUP_SUCCESS,
  };
}
export function resendApproveEmail(): ActionType {
  return {
    payload: null,
    type: RESEND_APPROVE_EMAIL,
  };
}
